import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';

class AchievementsContent extends Component {
    componentDidMount() {

    }
    render() {
        const { t } = this.props;

        return (
            <>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-9 col-md-12 col-sm-12">
                            <div className="content-inner">
                                {t('Achievements_Description.items', { returnObjects: true }).map((item, index) => (
                                    <div
                                        key={index}
                                        className="achievement-section"
                                        style={{ marginBottom: '40px' }}
                                    >
                                        <h6
                                            className="sub-title"
                                            style={{ marginTop: 0, marginBottom: '20px' }}
                                        >
                                            {item.Achievements_Content_Title}
                                        </h6>
                                        <div>
                                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                                {item.Content_data?.map((data, dataIndex) => (
                                                    <li key={dataIndex}
                                                        style={{ marginBottom: '16px', lineHeight: 1.6 }}
                                                    >
                                                        <div className="pathway-item">
                                                            <strong>{data.title}</strong>
                                                            <span>{data.desc}</span>
                                                        </div>

                                                        {data.subItems?.length > 0 && (
                                                            <ul
                                                                style={{
                                                                    marginTop: '5px',
                                                                    marginBottom: '8px',
                                                                    paddingLeft: '25px',
                                                                    listStyleType: 'circle',
                                                                }}
                                                            >
                                                                {data.subItems.map((subItem, subIndex) => (
                                                                    <li key={subIndex}
                                                                        style={{ marginBottom: '10px', lineHeight: 1.6 }}
                                                                    >
                                                                        <div>
                                                                            <strong>{subItem.heading}</strong>
                                                                            <span>{subItem.data}</span>
                                                                        </div>

                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AchievementsContent = withTranslation()(AchievementsContent);
